// dependencies
import React from "react";
import { Link } from "yarrr";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import TimeSeries from "./components/TimeSeries";
import BranchCheck from "./components/BranchCheck";
import GraphSelection from "./components/GraphSelection";

// actions
import { init, cleanup, initializeGraphs } from "./actions";

// selectors
import { getDeployments } from "Selectors/deployments";
import {
	getGraphWidth,
	getEnvironmentMeanResponseTime,
	getEnvironmentRequestCount,
	getEnvironmentCompanyCount,
	getEnvironmentActiveUserCount,
	getEnvironmentTotalUserCount,
} from "./selectors";

// css
import css from "./Dashboard";

class Dashboard extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		initializeGraphs: PropTypes.func.isRequired,
		cleanup: PropTypes.func.isRequired,
		graphWidth: PropTypes.number.isRequired,
		environmentMRT: PropTypes.number.isRequired,
		environmentRequestCount: PropTypes.number.isRequired,
		environmentCompanyCount: PropTypes.number.isRequired,
		environmentActiveUserCount: PropTypes.number.isRequired,
		environmentTotalUserCount: PropTypes.number.isRequired,
		environment: PropTypes.string.isRequired,
		deployments: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	constructor(props) {
		super(props);
		this.graphsContainer = React.createRef();
	}

	componentDidMount = () => {
		this.props.init(this.graphsContainer.current.offsetWidth);
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.initializeGraphs();
		}
	};

	componentWillUnmount = () => {
		this.props.cleanup();
	};

	render = () => {
		const {
			deployments,
			graphWidth,
			environmentMRT,
			environmentRequestCount,
			environmentCompanyCount,
			environmentActiveUserCount,
			environmentTotalUserCount,
		} = this.props;

		return (
			<div className={css.Dashboard}>
				<div className={css.dashRow}>
					<div className={css.dashBox}>
						<div className={css.innerBox}>
							<BranchCheck />

							<div className={css.viewOtherDeployments}>
								<Link className={css.lightButton} href="/lambda-functions">
									View Lambda Functions
								</Link>
							</div>

							{deployments.size > 0 ? (
								<div className={css.viewOtherDeployments}>
									<Link
										className={css.lightButton}
										href="/deployments"
									>{`View ${deployments.size} Other Deployment(s)`}</Link>
								</div>
							) : null}
						</div>
					</div>

					<div className={css.dashBox}>
						<div className={`${css.innerBox} ${css.statsContainer}`}>
							<div className={css.statWrapper}>
								<div className={css.dashboardLabel}>Mean Response Time</div>
								<div className={css.dashboardValue}>{`${environmentMRT.toFixed(3)}ms`}</div>
							</div>

							<div className={css.statWrapper}>
								<div className={css.dashboardLabel}>Request Count</div>
								<div className={css.dashboardValue}>{`${environmentRequestCount}`}</div>
							</div>
						</div>
					</div>

					<div className={css.dashBox}>
						<div className={`${css.innerBox} ${css.statsContainer}`}>
							<div className={css.statWrapper}>
								<div className={css.dashboardLabel}>Active Companies</div>
								<div className={css.dashboardValue}>{`${environmentCompanyCount}`}</div>
							</div>

							<div className={css.statWrapper}>
								<div className={css.dashboardLabel}>Active/Total Seats</div>
								<div className={css.dashboardValue}>
									{`${environmentActiveUserCount}`} / {`${environmentTotalUserCount}`}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div ref={this.graphsContainer} className={css.graphsContainers}>
					<div className={css.graphBox}>
						<div className={css.innerBox}>{graphWidth > 0 ? <TimeSeries /> : null}</div>
					</div>

					<div>
						<Link className={css.lightButton} href="/requests-report">
							Compare Daily
						</Link>
					</div>

					<div className={css.graphBox}>
						<div className={css.innerBox}>
							<GraphSelection />
						</div>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	graphWidth: getGraphWidth(state),
	deployments: getDeployments(state),
	environmentCompanyCount: getEnvironmentCompanyCount(state),
	environmentRequestCount: getEnvironmentRequestCount(state),
	environmentActiveUserCount: getEnvironmentActiveUserCount(state),
	environmentTotalUserCount: getEnvironmentTotalUserCount(state),
	environmentMRT: getEnvironmentMeanResponseTime(state),
});

const mapDispatchToProps = (dispatch) => ({
	cleanup: () => dispatch(cleanup()),
	initializeGraphs: () => dispatch(initializeGraphs()),
	init: (graphWidth) => dispatch(init(graphWidth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
